<template>
	<div class="doc-swiper-container">
		<swiper
			:modules="modules"
			:slides-per-view="1"
			:breakpoints="{
				'640': {
					slidesPerView: 1,
				},
				'768': {
					slidesPerView: 2,
				},
				'992': {
					slidesPerView: 3,
				},
				'1200': {
					slidesPerView: 3,
				},
				'1400': {
					slidesPerView: 4,
				},
			}"
			:space-between="22"
			navigation>
			<swiper-slide v-for="type in types" :key="`tool-${type.id}`" style="height: auto">
				<v-card class="w-100 flex-start flex-column elevation-1 rounded-1 h-100" :href="`/${type.slug}`">
					<div class="w-100 d-flex align-center justify-start py-5 px-5">
						<div
							class="dash-icon-wrap flex-center pa-3 mr-4"
							style="background-color: #0e081820; border-radius: 4px; width: 20px; height: 20px">
							<v-icon size="20" color="#0e0818">{{ type.icon }}</v-icon>
						</div>

						<h5 class="medium-text text-high-emphasis font-weight-regular" style="max-width: 60%">
							{{ type.name }}
						</h5>
					</div>

					<div class="w-100 px-5 flex-start" style="flex-wrap: wrap">
						<v-chip
							v-for="tag in type.doc_type_categories?.slice(0, 2)"
							:key="`tag-${tag.id}`"
							class="rounded-1 mr-2 mb-2"
							:color="tag.color"
							size="small">
							{{ tag.name }}
						</v-chip>

						<span class="small-text text-disabled" v-if="type.doc_type_categories?.length > 2">
							+{{ type.doc_type_categories.length - 2 }}
						</span>
					</div>

					<v-card-text class="px-5 text-medium-emphasis py-2">
						{{ type.description.slice(0, 80) }}{{ type.description.length > 80 ? "..." : "" }}
					</v-card-text>

					<v-spacer></v-spacer>

					<v-card-actions class="px-5 pt-0">
						<a class="dark-back-link" :href="`/${type.slug}`">
							Explore Tool
							<v-icon class="ml-2">mdi-chevron-right</v-icon>
						</a>
					</v-card-actions>
				</v-card>
			</swiper-slide>

			<swiper-slide v-if="remainingCount > 0" style="height: auto">
				<v-card class="w-100 flex-center flex-column elevation-1 rounded-1 h-100" href="/">
					<div class="w-100 d-flex align-center justify-center py-5 px-5 flex-column">
						<h2 class="text-medium-emphasis">+{{ remainingCount }} More</h2>

						<div class="w-100 d-flex align-center justify-center">
							<v-btn
								class="rounded-1 normal-spacing text-decoration-underline text-medium-emphasis"
								variant="plain">
								View All
							</v-btn>
						</div>
					</div>
				</v-card>
			</swiper-slide>
		</swiper>
	</div>
</template>
<script>
	import { Swiper, SwiperSlide } from "swiper/vue"
	import { Navigation } from "swiper/modules"
	import "swiper/css"
	import "swiper/css/navigation"
	import "swiper/css/pagination"
	import "swiper/css/scrollbar"

	// Import Swiper styles
	export default {
		components: {
			Swiper,
			SwiperSlide,
		},
		props: {
			types: {
				type: Array,
				required: true,
			},
			remainingCount: {
				type: Number,
				default: 0,
			},
		},
		setup() {
			return {
				modules: [Navigation],
			}
		},
	}
</script>
